import { render, staticRenderFns } from "./HIVESpacer.vue?vue&type=template&id=bd02373e&scoped=true&"
import script from "./HIVESpacer.vue?vue&type=script&lang=ts&"
export * from "./HIVESpacer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd02373e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
